export default __webpack_public_path__ + "static/media/savvi_logo.35b46257.svg";